import { createSimpleCache, CreateSimpleCacheOptions } from 'app/shared/lib/cache/create-simple-cache';
import { Sorting } from 'app/shared/lib/essette-site';
import * as UM from 'app/um/models/essette-api';

export interface IRoutingCacheState {
    authId?: string;

    // dropdowns
    authOwners: ReadonlyArray<UM.AuthOwner>;
    authQueues: ReadonlyArray<UM.AuthQueue>;

    // assignment history
    assignmentHistory: ReadonlyArray<UM.AuthAssignmentHistory>;
    assignmentHistoryPage?: number;
    assignmentHistoryResultCount?: number;
    assignmentHistorySorting?: Sorting;

    // queue history
    queueHistory: ReadonlyArray<UM.AuthQueueHistory>;
    queueHistoryPage?: number;
    queueHistoryResultCount?: number;
    queueHistorySorting?: Sorting;
}

export const routingCacheKey = 'ROUTING_CACHE';

export const createRoutingCache = (opts: CreateSimpleCacheOptions<IRoutingCacheState>) =>
    createSimpleCache<IRoutingCacheState>({ authOwners: [], authQueues: [], assignmentHistory: [], queueHistory: [] }, opts);

export type IRoutingCache = ReturnType<typeof createRoutingCache>;
